export default __webpack_public_path__ + "static/media/DOLL_P2.6970d2bf.svg";